import React from "react";
import { motion } from "framer-motion";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";
import { faqs } from "@/data/landing";
import { fadeUp } from "@/lib/motion";

const FAQ = () => {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="section py-24 md:py-32"
        >
            <div className="max-w-4xl mx-auto px-6 lg:px-10">
                <motion.div {...fadeUp} className="text-center">
                    <span className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.3em] text-cyan-300">
                        <HelpCircle className="h-4 w-4" /> 06 / FAQ
                    </span>
                    <h2
                        data-testid="faq-heading"
                        className="mt-4 font-display font-semibold text-white text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
                    >
                        Questions,{" "}
                        <span className="text-grad-cyan">answered.</span>
                    </h2>
                    <p className="mt-5 text-zinc-400 text-lg">
                        Couldn&apos;t find what you&apos;re looking for? Email{" "}
                        <a
                            href="mailto:mohd.aquib@atvicon.com"
                            className="text-cyan-300 hover:underline"
                        >
                            mohd.aquib@atvicon.com
                        </a>
                    </p>
                </motion.div>

                <motion.div {...fadeUp} className="mt-12">
                    <Accordion type="single" collapsible className="space-y-3">
                        {faqs.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="glass rounded-xl border-white/10 px-6 hover:bg-white/[0.06] transition"
                            >
                                <AccordionTrigger className="text-left text-white font-medium text-base md:text-lg hover:no-underline py-5">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-zinc-400 text-[15px] leading-relaxed pb-5">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </motion.div>
            </div>
        </section>
    );
};

export default FAQ;
